//We are coupling here the external dependencies (generic tools/components provided by our github repositories) with the specific functions of this application.
//This file is supposed to be reviewed and potentially rewritten for each application, depending of its structure.
import {Request} from "sp-react-commons";
import ReactValidation from "react-validation";
import Translation from "../../commons/i18n/Translation";
import Geolocation from "react-geolocation";
import { merge as _merge } from "lodash";
import AppConfig from "AppConfig";

export default class ExternalDependenciesConfiguration {
    static configure = () => {
        Request.Config.withCredentials = true;

        // React Validation
        ReactValidation.Config.ICON_VALID_CLASS = "icon-check";
        ReactValidation.Config.ICON_ERROR_CLASS = "icon-exclamation-triangle";
        ReactValidation.Config.MESSAGES = _merge(ReactValidation.Config.MESSAGES, Translation.get("react-validation.messages"));
        ReactValidation.Config.ERROR_MESSAGE_FIELD_NAME = Translation.translate("react-validation.error-message-field-name");
        ReactValidation.Config.COUNT_MESSAGE = (count) => Translation.translate("react-validation.count-message", { count: count });

        // Geolocation
        Geolocation.Config.GOOGLE_MAPS_API_KEY = AppConfig.googleMapApiKey;
    };
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/configurations/ExternalDependenciesConfiguration.js